import axios from '@/axios'
import apiUrl from '@/axios/config.js'
let host = location.host
let cmsApiUrl = ''
if (host.indexOf('localhost') > -1 || host.indexOf('.lan') > -1 || host.indexOf('192.168') > -1) {
  cmsApiUrl = 'http://m.proway.lan'
} else {
  cmsApiUrl = 'https://m.prowayxau.com'
}
const service = {
  //投诉建议提交
  async suggestionSub(params) {
    return await axios.post('/uc/api/servicecenter/advise', params, { headers: { lang: 'en_us' } }, { des: '直客pc投诉建议提交', sTime: new Date().getTime() })
  },
  //投诉建议列表
  async getSuggesList(params) {
    return await axios.get('/uc/api/servicecenter/advise', params, { lang: 'en_us' }, { des: '直客pc投诉建议列表', sTime: new Date().getTime() })
  },
  //我的消息列表 --- 站内信
  async getMymsgList(params) {
    return await axios.post('/uc/user/notice/list', params, { des: '直客pc我的消息列表', sTime: new Date().getTime() })
  },
  //获取消息列表详情 --站内信详情
  async getListDetail(params) {
    return await axios.post('/uc/user/notice/detail', params, { des: '直客pc获取消息列表详情', sTime: new Date().getTime() })
  },

  //获取公告
  async getNoticeList(params) {
    return await axios.post('/cms/api/services/app/Notice/ViewList', params, { des: '用户获取公告', sTime: new Date().getTime(), baseUrl: cmsApiUrl })
  },
  // 公告详情  测试地址：http://m.proway.lan  线上地址：https://m.prowayfx.com
  async getNoticeDetailApi(params) {
    return await axios.post('/cms/api/services/app/Notice/View', params, { des: '公告详情', sTime: new Date().getTime(), baseUrl: cmsApiUrl })
  },
}

export default service



// WEBPACK FOOTER //
// ./src/api/service.js